import { useTheme } from '@mui/material'
import { Box } from '@mui/system'
import CloseIcon from '@mui/icons-material/Close'

const AdxFullWindowTitleBar = ({ children, sx, onClose, ...rest }) => {
  const { typography, palette } = useTheme()

  const defaultProp = () => {
    return {
      fontSize: typography.h3,
      color: palette['dark-text'].main,
      bgcolor: palette['white'].main,
      borderBottom: `1px solid ${palette['gray-line'].main}`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      px: '2%',
      py: '14px',
      width: '100%',
      gap: 2,
    }
  }

  const handleClick = () => onClose()

  return (
    <Box sx={{ ...defaultProp(), ...sx }} {...rest}>
      {children}
      <CloseIcon onClick={handleClick} sx={{ cursor: 'pointer', color: 'dark-text.main' }} />
    </Box>
  )
}
export default AdxFullWindowTitleBar
